import { cloudFunction } from '../parse';

export const fetchAllRecipeUnits =()=>{
  return cloudFunction('fetchAllRecipeUnits', {});
};

export const createRecipe = (recipeData: Record<string, any>) => {
  return cloudFunction('createRecipe', recipeData);
};

export const updateRecipe = (recipeData: Record<string, any>) => {
  return cloudFunction('updateRecipe', recipeData);
};

export const deleteRecipe = (id: string) => {
  return cloudFunction('deleteRecipe', { id });
};

export const fetchRecipe = (id: string) => {
  return cloudFunction('fetchRecipe', { id });
};

export const fetchPaginatedRecipes =(filterData: Record<string, any>) => {
  return cloudFunction('fetchPaginatedRecipes',filterData);
};

export const fetchAllInventoryItemsForRecipe = (id: string) => {
  return cloudFunction('fetchAllInventoryItemsForRecipe', { recipeId:id });
};

export const addInventoryItemToRecipe = (data: Record<string, any>) => {
  return cloudFunction('addInventoryItemToRecipe', data);
};

export const removeInventoryItemFromRecipe = (recipeId,inventoryItemId) => {
  return cloudFunction('removeInventoryItemFromRecipe', { recipeId,inventoryItemId });
};